import React, { useCallback, useEffect, useRef, useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import "./App.css";
import Store from "./pages/stores";
import Global from "./pages/global";
import Carrier from "./pages/carriers";
import Report from "./pages/reports";
import Gdpr from "./pages/gdpr";
import { Navigate, Route, Routes, useNavigate } from "react-router-dom";
import Setting from "./pages/setting";
import UserCustomDashboard from "./pages/userCustomDashboard";
import { Frame, Navigation, TopBar, Avatar, Popover, Icon } from "@shopify/polaris";
import "./pages/global.css";
import ProtectedRoute from "./context/auth/protect-route";
import UserDashboard from "./pages/userCustomDashboard/dashboard";
import CourierMapping from "./pages/userCustomDashboard/settings/CourierMapping";
import Orders from "./pages/userCustomDashboard/orders";
import TroubleShoot from "./pages/troubleshooting";
import HistoricalOrder from "./pages/userCustomDashboard/HistoricalOrders";
import Partners from "./pages/userCustomDashboard/partners";
import DigitalProduct from "./pages/userCustomDashboard/settings/DigitalProduct";
import Subscription from "./pages/userCustomDashboard/settings/Subscription";
import PaypalSetting from "./pages/userCustomDashboard/settings/PaypalSetting"; 
import Usage from "./pages/userCustomDashboard/settings/Usage";
import Charges from "./pages/userCustomDashboard/settings/Charges";

import {
  AnalyticsMinor,
  CircleRightMajor,
  ConversationMinor,
  NotificationMajor,
  SettingsMajor,
  ShipmentMajor,
  StoreMajor,
  AnalyticsMajor
} from "@shopify/polaris-icons";
import { HeaderLogo } from "./assets";
import OrderGenerator from "./pages/userCustomDashboard/settings/OrderGenerator";

// The Stores list is the home page; the old Dashboard address, which Auth0 still returns to after login, forwards here.
const RedirectToStores = () => <Navigate to="/store" replace />;

const Main = (props) => {
  useEffect(() => {
    console.log(window.location.pathname);
    if (window.location.pathname === "/") {
      props.setState("/");
    } else if (window.location.pathname === "/login") {
      props.setState("/login");
    } else {
      props.setState("/dashboard");
    }
  }, [props.state]);
  const navigate = useNavigate();
  const skipToContentRef = useRef < HTMLAnchorElement > null;
  const [userMenuActive, setUserMenuActive] = useState(false);
  const [mobileNavigationActive, setMobileNavigationActive] = useState(false);
  const [modalActive, setModalActive] = useState(false);

  const { user = {}, logout } = useAuth0();
  const [name, setName] = useState();

  useEffect(() => {
    if(user){
      setName(user?.nickname);
    }
  },[user])

  const toggleUserMenuActive = useCallback(() => {
    setUserMenuActive(!userMenuActive);
  }, [userMenuActive]);

  const handleLogout = useCallback(() => {
    localStorage.clear();
    sessionStorage.clear();
    logout({
      returnTo: window.location.origin,
    })
  }, []);

  const toggleMobileNavigationActive = useCallback(
    () =>
      setMobileNavigationActive(
        (mobileNavigationActive) => !mobileNavigationActive
      ),
    []
  );
  const handleNavigation = (tabname, tabs) => {
    navigate(tabname);
  };

  const toggleModalActive = useCallback(
    () => setModalActive((modalActive) => !modalActive),
    []
  );

  const activator = (
    <span
    className="d-flex gap-10 cursor_pointer aligns-Items-center mr- justify-content-center"

      onClick={toggleUserMenuActive}
    >
      <p className="capitalize">{name}</p>
      <Avatar name="Shop One" shape="square" />
    </span>
  );

  const userMenuMarkup = (
    <Popover
      active={userMenuActive}
      activator={activator}
      autofocusTarget="first-node"
      onClose={toggleUserMenuActive}
    >
      <div className="d-flex p-15 gap-10 cursor_pointer" style={{ background:"#fff"}}
        onClick={() => {
          handleLogout();
        }}
      >
        <Icon source={CircleRightMajor}   color="base"/>
        <p>Logout</p>
      </div>
    </Popover>
  );

  const topBarMarkup = (
    <TopBar
      showNavigationToggle
      userMenu={userMenuMarkup}
      onNavigationToggle={toggleMobileNavigationActive}
    />
  );

  const navigationMarkup = (
    <Navigation location={"/store"}>
      <Navigation.Section
        items={[
          {
            label: "Stores",
            icon: StoreMajor,
            onClick: () => {
              handleNavigation("store", 1);
            },
            // Store detail pages are opened from the Stores list, so they keep it selected.
            selected:
              window.location.pathname === "/store" ||
              window.location.pathname.startsWith("/viewStore/"),
          },

          {
            label: "Gdpr",
            icon: AnalyticsMajor,
            onClick: () => {
              handleNavigation("gdpr", 2);
            },
            selected: window.location.pathname === "/gdpr" ? true : false,
          },
          // {
          //   label: "Global",
          //   icon: NotificationMajor,
          //   onClick: () => {
          //     handleNavigation("global", 2);
          //   },
          //   selected: window.location.pathname === "/global" ? true : false,
          // },
          // {
          //   label: "Carriers",
          //   icon: ShipmentMajor,
          //   onClick: () => {
          //     handleNavigation("carrier", 3);
          //   },
          //   selected: window.location.pathname === "/carrier" ? true : false,
          // },
          // {
          //   label: "Reports",
          //   icon: AnalyticsMinor,
          //   onClick: () => {
          //     handleNavigation("report", 4);
          //   },
          //   selected: window.location.pathname === "/report" ? true : false,
          // },
        ]}
        action={{
          icon: ConversationMinor,
          accessibilityLabel: "Contact support",
          onClick: toggleModalActive,
        }}
      />
      {/* <Navigation.Section
        items={[
          {
            label: "Setting",
            icon: SettingsMajor,
            onClick: () => {
              handleNavigation("setting", 7);
            },
            selected: window.location.pathname === "/setting" ? true : false,
          },
        ]}
      /> */}
    </Navigation>
  );

  const logo = {
    width: 150,
    topBarSource: HeaderLogo,
  };

  return (
    <>
      <Frame
        logo={
          props.state === "/login" ? null : props.state !== "/" ? logo : null
        }
        topBar={
          props.state === "/login"
            ? null
            : props.state !== "/"
            ? topBarMarkup
            : null
        }
        navigation={
          props.state === "/login"
            ? null
            : props.state !== "/"
            ? navigationMarkup
            : null
        }
        showMobileNavigation={mobileNavigationActive}
        onNavigationDismiss={toggleMobileNavigationActive}
        skipToContentTarget={skipToContentRef}
      >
        <Routes>
          {/* Auth0 returns here after login (REACT_APP_AUTH0_LOGIN_REDIRECT_URI ends in /dashboard). The route must stay
              protected so the login completes first: redirecting straight away drops ?code=&state= and loops back to Auth0. */}
          <Route path="/dashboard" element={<ProtectedRoute component={RedirectToStores} />} />
          <Route path="/store" element={<ProtectedRoute component={Store} />} />
          <Route path="/global" element={<ProtectedRoute component={Global} />} />
          <Route path="/carrier" element={<ProtectedRoute component={Carrier} />} />
          <Route path="/report" element={<ProtectedRoute component={Report} />} />
          <Route path="/gdpr" element={<ProtectedRoute component={Gdpr} />} />
          <Route path="/setting" element={<ProtectedRoute component={Setting} />} />
          <Route path="/trobleshoot" element={<ProtectedRoute component={TroubleShoot} />} />
          <Route path="/viewStore/:id/:storeType" element={<ProtectedRoute component={UserCustomDashboard} />}>
            <Route path="" element={<UserDashboard />} />
            <Route path="orders" element={<Orders />} />
            <Route path="courier-mapping" element={<CourierMapping />} />
            <Route path="historical-orders" element={<HistoricalOrder />} />
            <Route path="trouble-shooting" element={<TroubleShoot />} />
            <Route path="partners" element={<Partners />} />
            <Route path="subscription" element={<Subscription />} />
            <Route path="usage" element={<Usage />} />
            <Route path="digital-product" element={<DigitalProduct />} />
            <Route path="paypalsetting" element={<PaypalSetting />} />
            <Route path="charges" element={<Charges />} />
            { process.env.REACT_APP_IS_STAGING && <Route path="order-generator" element={<OrderGenerator />} /> }
          </Route>
        </Routes>
      </Frame>
    </>
  );
};

export default Main;
